import _axios from "axios"

import { repository as repoEnv } from "../../public/config"

const axios = _axios

const instance = axios.create({
    baseURL: repoEnv.baseURL,
    timeout: repoEnv.timeout || 10000,
    withCredentials: true,
    headers: {
        get: {
            "Accept": "application/json"
        },
        post: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
    }
})

export default instance